/* eslint-disable import/no-extraneous-dependencies */
// import DisableDevtool from 'disable-devtool';
import { useEffect, useState } from 'react';
import { isExpired } from 'react-jwt';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { userSignIn, userSignOut } from '../redux/slices/auth/authSlice';

export default function useAuthCheck() {
  const [authChecked, setAuthChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Call DisableDevtool() only if NODE_ENV is production
  // if (process.env.NODE_ENV === 'production') {
  //   DisableDevtool();
  // }

  const checkUserMatchApi = async (authToken) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/get-current-user`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${authToken}`,
      },
    });
    const data = await response.json();
    return data;
  };

  const checkResponseStatus = async (authToken) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/get-current-user`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${authToken}`,
      },
    });
    const { status } = response;
    return status;
  };

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const localAuth = localStorage.getItem('auth');
        const authToken = JSON.parse(localAuth);
        const accessTokenString = authToken?.accessToken;
        const isTokenExpired = isExpired(accessTokenString);

        if (localAuth) {
          const auth = JSON.parse(localAuth);
          if (auth?.accessToken && auth?.user) {
            dispatch(
              userSignIn({
                accessToken: auth.accessToken,
                refreshToken: auth.refreshToken,
                user: auth.user,
              }),
            );

            // Call your API to check if the stored user matches the current user
            const isUserMatch = await checkUserMatchApi(accessTokenString); // Pass the user ID to your API function
            const resStatus = await checkResponseStatus(accessTokenString);

            if ((authToken.user.email === isUserMatch.email) && resStatus !== 200) {
              dispatch(userSignOut());
              navigate('/auth/sign-in', { replace: true });
              return; // Exit early if user doesn't match
            }
          }
          setAuthChecked(true);
        } else if (isTokenExpired) {
          dispatch(userSignOut());
          navigate('/auth/sign-in', { replace: true });
        } else {
          // TODO: Toast user invalid credentials and let them sign in again
          dispatch(userSignOut());
          navigate('/auth/sign-in', { replace: true });
        }
      } catch (err) {
        // TODO: Customize Error Message
        console.error(err);
        dispatch(userSignOut());
        navigate('/auth/sign-in', { replace: true });
      } finally {
        setLoading(false);
      }
    };

    verifyUser();
  }, [dispatch, navigate, setAuthChecked]);

  return { authChecked, loading };
}
